import ChannelShow from '../messaging/ChannelShow'

export const channels = {
  show: ChannelShow,
}
